import React, { useState, useEffect, memo } from 'react';
import ReactStreetview from "react-streetview";

const GalleryStreetView = ({gmapKey, coordinates}) => {
  const [error, setError] = useState(null);
  const [streetViewLoaded, setStreetViewLoaded] = useState(false);
  
  const streetViewPanoramaOptions = {
    position: coordinates,
    pov: { heading: 100, pitch: 0 },
    zoom: 1,
  };

  useEffect(() => {
    if (coordinates?.lat && coordinates?.lng) {
      const sv = new google.maps.StreetViewService();
      sv.getPanorama({location: coordinates, radius: 50}, function(data, status) {
        setStreetViewLoaded(true);
        if (status !== 'OK') {
          setError("Street View is not available for this property.");
        }
      });
    } else {
      setStreetViewLoaded(true);
      setError("Street View is not available for this property.");
    }
  }, []);

  if (error) {
    return (
      <div className='street-error-container'>
        <b>{error}</b>
        {!streetViewLoaded && (
          <div className='street-loader-container'>
            <div className="street-view-loader"></div>
            <div className="street-view-loader-text">Loading...</div>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className='street-view-container'>
        <ReactStreetview
          apiKey={gmapKey}
          streetViewPanoramaOptions={streetViewPanoramaOptions}
        />
        {!streetViewLoaded && (
          <div className='street-loader-container'>
            <div className="street-view-loader"></div>
            <div className="street-view-loader-text">Loading...</div>
          </div>
        )}
      </div>
    );
  }
};
export default memo(GalleryStreetView);

